import { RemoteCollectionStore } from "@softline/core";
import { Content } from "../types/content.model";

export const ContentStore = RemoteCollectionStore.create<Content>();

